export default __webpack_public_path__ + "static/face-value-664dd3d66d8264c15cb001095afb2ffb.png";